import React from "react"
import AllianzDeletion from "components/Shared/User/AllianzDeletion"

const AllianzDeletionScreen = () => <AllianzDeletion/>

export default AllianzDeletionScreen